/* TOMA UNO — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.t1-reveal:not(.t1-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('t1-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('t1-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initRec() {
    document.querySelectorAll('[data-t1-rec]').forEach(function (el) {
      if (el.dataset.t1Init) return; el.dataset.t1Init = '1';
      var s = 0;
      setInterval(function () {
        s++;
        var m = String(Math.floor(s / 60)).padStart(2, '0'), ss = String(s % 60).padStart(2, '0');
        el.textContent = '00:' + m + ':' + ss;
      }, 1000);
    });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-t1-num]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.dataset.t1Num) || 0, dec = (el.dataset.t1Num.split('.')[1] || '').length;
      var sep = el.dataset.t1Sep === 'true';
      function fmt(v) { var t = v.toFixed(dec); if (sep) t = Number(t).toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }); return t; }
      if (reduce) { el.textContent = fmt(fin); return; }
      var t0 = null, dur = 1600;
      function paso(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); p = 1 - Math.pow(1 - p, 3); el.textContent = fmt(fin * p); if (p < 1) requestAnimationFrame(paso); }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } }); }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initProducto() {
    document.querySelectorAll('[data-t1-producto]').forEach(function (root) {
      if (root.dataset.t1Init) return; root.dataset.t1Init = '1';
      var principal = root.querySelector('[data-t1-principal]');
      function mostrar(src, srcset, id) {
        if (!principal) return;
        principal.style.opacity = 0;
        setTimeout(function () { principal.src = src; if (srcset) principal.srcset = srcset; principal.style.opacity = 1; }, 150);
        root.querySelectorAll('.t1-mini').forEach(function (m) { m.classList.toggle('is-activa', m.dataset.mediaId === String(id)); });
      }
      root.querySelectorAll('.t1-mini').forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.srcset, m.dataset.mediaId); });
      });

      var json = root.querySelector('[data-t1-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = root.querySelector('[data-t1-boton]');
      var precio = root.querySelector('[data-t1-precio]');
      var tachado = root.querySelector('[data-t1-tachado]');
      var ahorro = root.querySelector('[data-t1-ahorro]');
      var aviso = root.querySelector('[data-t1-aviso]');
      var fmt = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2), partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var coma = miles + ',' + partes[1];
        var punto = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1];
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles).replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0]).replace(/\{\{\s*amount\s*\}\}/, punto).replace(/<[^>]*>/g, '');
      }
      root.querySelectorAll('.t1-opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          // Si la combinación elegida no existe (p. ej. un color que solo viene en 1 unidad),
          // ajusta automáticamente las demás opciones a la primera combinación disponible.
          var grupos = Array.prototype.slice.call(root.querySelectorAll('.t1-opcion'));
          var idx = grupos.indexOf(inp.closest('.t1-opcion'));
          var actual = grupos.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
          var existe = variantes.some(function (x) { return x.options.every(function (o, i) { return o === actual[i]; }); });
          if (!existe && idx > -1) {
            var alt = variantes.find(function (x) { return x.options[idx] === inp.value && x.available; }) || variantes.find(function (x) { return x.options[idx] === inp.value; });
            if (alt) grupos.forEach(function (fs, i) {
              fs.querySelectorAll('input').forEach(function (r) { if (r.value === alt.options[i]) r.checked = true; });
            });
          }
          var sel = [];
          root.querySelectorAll('.t1-opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
            var lbl = fs.querySelector('[data-t1-valor]'); if (lbl && c) lbl.textContent = c.value;
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.dataset.noDisponible; } return; }
          if (inputId) inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          if (ahorro) { if (v.compare_at_price > v.price) { ahorro.hidden = false; ahorro.textContent = ahorro.dataset.prefijo + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } else { ahorro.hidden = true; } }
          if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado; }
          if (aviso) aviso.textContent = v.available ? '' : boton.dataset.agotado;
          if (v.featured_media && v.featured_media.preview_image) {
            var mini = root.querySelector('.t1-mini[data-media-id="' + v.featured_media.id + '"]');
            if (mini) mostrar(mini.dataset.src, mini.dataset.srcset, mini.dataset.mediaId);
          }
          if (window.history && window.history.replaceState) {
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
          }
        });
      });
    });
  }

  function initAll(root) { initReveal(root); initRec(); initCifras(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
